

function Links() {
  return <div className="main-wrapper">
    
      

      <h2>Weiterführende Links und Hilfsangebote</h2>

      <p style={{marginTop: "50px"}}>
        <a href="../files/Notfallnummern_Beratungsstellen_10-04-2026.pdf" target="_blank" rel="noopener noreferrer">
          Download Notfallnummern & Beratungsstellen
        </a>
      </p>

      <h3>
        1. Notfallnummern und Krisendienst
      </h3>

      <table>
        <tr>
          <td>Polizei</td>
          <td>110</td>
        </tr>
        <tr>
          <td>Feuerwehr und Rettungsdienst<br/>(bei lebenbedrohlichem Notfall)</td>
          <td>112</td>
        </tr>
        <tr>
          <td>Krisendienst Psychiatrie Bayern (0-24 Uhr)<br/>Hilfe bei psychischen Krisen<br/><a href="https://www.krisendienste.bayern/oberbayern/" target="_blank" rel="noopener noreferrer">krisendienste.bayern/oberbayern</a></td>
          <td>0800 655 3000</td>
        </tr>
        <tr>
          <td>Ärztlicher Bereitschaftsdienst Bayern<br/>(umgehend ärztliche Hilfe, nicht lebensbedrohlich)</td>
          <td>116 117</td>
        </tr>
        <tr>
          <td>Kinder- & Jugendtelefon</td>
          <td>116 111</td>
        </tr>
        <tr>
          <td>Sucht- und Drogen-Hotline</td>
          <td>0180 631 30 311</td>
        </tr>
        <tr>
          <td>Giftnotruf</td>
          <td>089 19 240</td>
        </tr>
        <tr>
          <td>Frauennotruf München<br/><a href="https://frauennotruf-muenchen.de/" target="_blank" rel="noopener noreferrer">frauennotruf-muenchen.de</a></td>
          <td>089 76 37 37</td>
        </tr>
        <tr>
          <td>Evangelische Telefonseelsorge</td>
          <td>0800 111 01 11</td>
        </tr>
        <tr>
          <td>Katholische Telefonseelsorge</td>
          <td>0800 111 02 22</td>
        </tr>
      </table>

      <h3>
        2. Sozialpsychiatrische Dienste (SPDi)
      </h3>

      <p>
        Beratungsstellen für Menschen mit seelischen Problemen und deren Angehörige, die auch in akuten Krisensituationen informieren und unterstützen. Die Teams bestehen aus medizinisch-psychiatrisch, psychologisch und sozialpädagogisch geschulten Fachleuten, die Ihnen zur Seite stehen und Sie bei Bedarf an weitere spezifische Stellen vermitteln.
      </p>

      <p>
        Die jeweilige Zuständigkeit richtet sich nach Ihrem Wohnort, zu finden unter:<br/>
        <a href="https://stadt.muenchen.de/service/info/beratung-von-menschen-mit-psychischen-problemen/1072069/n0/" target="_blank" rel="noopener noreferrer">stadt.muenchen.de/service/info/beratung-von-menschen-mit-psychischen-problemen/1072069/n0/</a>
      </p>

      <h3>
        3. Beratungsstellen für Familien, Kinder und Jugendliche
      </h3>

      <p>
        Fragen zu Schwangerschaft, Sexualität, Partnerschaft oder Eltern-sein?
      </p>

      <table>
        <tr>
          <td>Pro Familia e.V.<br/>Bodenseestr. 226<br/>81243 München<br/><a href="https://www.profamilia.de" target="_blank" rel="noopener noreferrer">profamilia.de</a></td>
          <td>089 - 897 67 30</td>
        </tr>
        <tr>
          <td>Hilfe bei allen Lebensfragen:<br/>Evangelisches Beratungszentrum München (ebz)<br/>Landwehrstr. 15 Rgb<br/>80336 München<br/><a href="https://www.ebz-muenchen.de" target="_blank" rel="noopener noreferrer">ebz-muenchen.de</a></td>
          <td>089 - 55 56 21</td>
        </tr>
      </table>



      <h2 style={{marginTop: "100px"}}>
        Weiterführende Links
      </h2>

      <h3>
        Holistische Tanz- und Bewegungstherapie (TherapeutInnen-Netzwerk)
      </h3>

      <a href=" https://holistische-tanztherapie.de" target="_blank" rel="noopener noreferrer">
        holistische-tanztherapie.de
      </a>

      <h3>
        zibko, Zentrum „In BeWEGung kommen", Barbara Hundshammer
      </h3>

      <a href="https://zibko.de" target="_blank" rel="noopener noreferrer">
        zibko.de
      </a>

    </div>
}
export default Links;